import { PARTS, partStates } from "./progressParts";

/** Where the candidate is in the thinking page, grouped into the parts they recognise. */

export function ThinkingProgress({
  step,
  progress,
  total,
}: {
  step: string;
  progress: number;
  total: number;
}) {
  const states = partStates(step);
  // `progress` counts completed screens (intro = 0); show the screen being worked on.
  const screens = total - 1; // intro isn't a question screen
  const percent = total > 0 ? Math.round((progress / total) * 100) : 0;
  const caption =
    step === "intro" ? "Not started" : `Step ${Math.min(progress, screens)} of ${screens}`;
  return (
    <div className="thinking-progress">
      <div
        className="progress-track"
        role="progressbar"
        aria-label="Progress"
        aria-valuemin={0}
        aria-valuemax={total}
        aria-valuenow={progress}
        aria-valuetext={caption}
      >
        <div className="progress-fill" style={{ width: `${percent}%` }} />
      </div>
      <ol className="progress-parts">
        {PARTS.map((part, i) => (
          <li
            key={part.label}
            className={states[i]}
            aria-current={states[i] === "current" ? "step" : undefined}
          >
            {part.label}
          </li>
        ))}
      </ol>
      <p className="progress-caption muted">{caption}</p>
    </div>
  );
}
